import React from 'react';
import clsx from 'clsx';
import { IconName } from '../SVGIcon/SVGIcon.types';
import { SVGIcon } from '../SVGIcon/SVGIcon';

export interface TabContentItem {
  id: string | number;
  label: string;
  value: string;
}

export interface TabContentProps {
  items: TabContentItem[];
  className?: string;
  title?: string;
  icon?: IconName;
  /**
   * Rozmiar prawej kolumny z wartością
   * @default 'small' - 160px
   * 'wide' - 50%
   */
  size?: 'small' | 'wide';
}

/**
 * Komponent do wyświetlania zawartości taba zgodnie z designem Figmy
 * Prosty layout z dwoma kolumnami: label (lewa) i wartość (prawa)
 */
export const TabContent: React.FC<TabContentProps> = ({
  items,
  className,
  title,
  icon,
  size = 'small',
}) => {
  if (!items || items.length === 0) {
    return (
      <div className="flex items-center justify-center py-8 text-grayText">
        Brak danych do wyświetlenia
      </div>
    );
  }

  return (
    <div className={clsx('w-full', className)}>
      {title && (
        <div className="mb-7 flex items-center gap-x-4">
          {icon && (
            <SVGIcon
              name={icon}
              width={36}
              height={36}
              size="sm"
              fill="blue"
              className="rounded-[8px] bg-[#ECF1F9] p-2 text-blueLightest"
            />
          )}
          <h5 className="text-[20px] font-semibold text-black">{title}</h5>
        </div>
      )}
      {items.map((item) => {
        return (
          <div
            key={item.id}
            className={clsx(
              'flex w-full border-grayBorder bg-white',
              'mb-3 rounded-card border',
            )}
          >
            {/* Lewa kolumna - Label */}
            <div
              className={clsx(
                'flex flex-1 items-center justify-start',
                'border-r border-grayBorder',
                'py-4 pl-5 pr-5 lg:py-4 lg:pl-7',
              )}
            >
              <span className="font-inter text-sm font-semibold leading-[1.375] text-text-primary lg:text-base">
                {item.label}
              </span>
            </div>

            {/* Prawa kolumna - Wartość */}
            <div
              className={clsx('flex items-center', 'px-5 py-0', {
                'w-[160px] justify-center text-center': size === 'small',
                'w-1/2 text-left': size === 'wide',
              })}
            >
              <span className="text-center font-inter text-sm font-normal leading-[1.375] text-grayText lg:text-base">
                {item.value}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
};
